export default {
  'powerBiServer.title': 'Gestionar Servidores Power BI',
  'powerBiServer.isPremium': 'Premium',
  'powerBiServer.authorityUrl': 'URL de autoridad',
  'powerBiServer.resourceUrl': 'URL de recurso',
  'powerBiServer.apiUrl': 'URL de API',
  'powerBiServer.embedUrlBase': 'URL base de inserción',
  'powerBiServer.redirectUrl': 'URL de redirección',
  'powerBiServer.username': 'Usuario',
  'powerBiServer.clientId': 'ID de cliente',
  'powerBiServer.clientSecret': 'Secreto de cliente',
};
